<button class="w-full outline-button-content" (click)="triggerEvent()" mat-flat-button>
  <span>{{ text }}</span>
</button>
